var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeline2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1106,
    height: 540,
    viewBox: "0 0 1106 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C81.5 39.5 -30.7532 251.859 232.443 192.734C490.088 134.857 610.476 215.043 627.691 284.588C648.466 368.52 810.789 557.207 1105 536.411",
    stroke: "#FF671F",
    strokeWidth: 4,
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeline2);
export default __webpack_public_path__ + "static/media/Home.line2.21a5bd7ec5f47669bc42e75c809514d5.svg";
export { ForwardRef as ReactComponent };